import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, requireProfileComplete = false }) => {
  const { isAuthenticated = false, loading = false, profileComplete = false } = useSelector(
    (state) => state.auth || {}
  );

  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (requireProfileComplete && !profileComplete) {
    return <Navigate to="/user-details" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
